import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/movimientocompra';
import moment from 'moment';
import Select from 'react-select';

import {api} from '../../actions/_request';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ProductosModal from "./ProductosModal";


import Embarques from "../embarques/Modal";
import LAB from "../lab/Modal";
import Proveedor from "../proveedores/Modal";
import Articulo from "../inventario/Modal";
import Almacen from "../almacenes/Modal";

const motivos = [
  {label: 'Hardware', value: 0},
  {label: 'Administrativo', value: 1}, 
  {label: 'Personal', value: 2}, 
];

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

const tipos_precios = [
  {label: 'Pesos', value: 0},
  {label: 'Dolares', value: 1}, 
];

const tipos_compra = [
  {label: 'Normal', value: 0},
  {label: 'Proyectos', value: 1}, 
];


class EmbarqueModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            compra: {
                id:0,
                factura:'',
                concepto:'COMPRA',
                fecha: moment().format('Y-MM-DD'),
                folio:'',
                proveedor_id:0,
                almacen_id:0,
                pedimento:'',
                fecha_pedimento:null,
                tipo_cambio:0,
                lab:0,
                via_emb:0,
                terminos:0,
                entrega:0,
                dias:0,
                comentario:'',
                recibo:'',
                importe_pagado:0,
                referencia:'',
                concepto_pago:'',
                cargo1:0.00,
                cargo2:0.00,
                impuesto_cargo1:0,
                impuesto_cargo2:0,
                devoluciones:0,
                impuesto_devoluciones:0,
                rebajas:0,
                impuesto_rebajas:0,
                pronto_pago:0,
                impuesto_pronto_pago:0,
                bonificaciones:0,
                impuesto_bonificaciones:0,
                importe:"0.00",
                descuento:"0.00",
                subtotal:"0.00",
                cargos:"0.00",
                ieps:"0.00",
                impuestos:"0.00",
                total:"0.00",
                saldo:0,
                moneda:0,  
                tipo_id:0,   
                motivo:1          
            },
            action: 'save',
            activeTab: '1',
            /**variables para el modal de productos*/
            modal_productos:false,
            renglon:[],
            indice:null,
            productos:[],
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            almacen_codigo:'',
            almacen_descripcion:"",
            codigo_lab:'',
            codigo_via_emb:'',
            /*variables del formulario*/
            saldo:'$0.00',
            credito:'$0.00',
            productos_importe:0,
            productos_descuento:0,
            productos_ieps:0,
            productos_impuestos:0,
            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',
            abonado:false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.handleInputChangeConteo= this.handleInputChangeConteo.bind(this);

        this.toggle_productos= this.toggle_productos.bind(this); 
        this.producto_modal= this.producto_modal.bind(this); 
        this.eliminar_producto= this.eliminar_producto.bind(this);
        

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this); 
                 
    }

     modal_open(){
       document.getElementById('body').className = "modal-open modal-open";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
        setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
        console.log('nada')
        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }

    handleInputChangeConteo(event) {
        let {compra,productos} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;
     
  this.calcular_totales(productos,compra);
    }

    calcular_totales(productos,compra){
      
      let importe=0;
      let descuento=0;
      let subtotal=0;
      let cargos=0;
      let ieps=0;
      let impuesto=0;
      let total=0;

      for (var i = productos.length - 1; i >= 0; i--) {
        importe+=parseFloat( productos[i].costo_total);
        descuento+=parseFloat( productos[i].cantidad_descuento);
        impuesto+=parseFloat( productos[i].cantidad_impuesto1)+parseFloat( productos[i].cantidad_impuesto2);
        ieps+=parseFloat( productos[i].ieps_total);

      }

      importe-=parseFloat(compra.devoluciones);
      importe-=parseFloat(compra.rebajas);
      importe-=parseFloat(compra.pronto_pago);
      importe-=parseFloat(compra.bonificaciones);

      cargos=parseFloat(compra.cargo1)+parseFloat(compra.cargo2);
      let cantidad_cargo1=(parseFloat(compra.impuesto_cargo1)/100)*parseFloat(compra.cargo1);
      let cantidad_cargo2=(parseFloat(compra.impuesto_cargo2)/100)*parseFloat(compra.cargo2);

      impuesto-=parseFloat(compra.impuesto_devoluciones);
      impuesto-=parseFloat(compra.impuesto_rebajas);
      impuesto-=parseFloat(compra.impuesto_pronto_pago);
      impuesto-=parseFloat(compra.impuesto_bonificaciones);


      impuesto+=cantidad_cargo2+cantidad_cargo1;


      subtotal=importe - descuento;
      total=subtotal+cargos+ieps+impuesto;

     


      compra.importe=this.trunc(importe,2);
      compra.descuento=this.trunc(descuento,2);
      compra.subtotal=this.trunc(subtotal,2);
      compra.cargos=this.trunc(cargos,2);
      compra.ieps=this.trunc(ieps,2);
      compra.impuestos=this.trunc(impuesto,2);
      compra.total=this.trunc(total,2);

      





      this.setState({
            compra : compra,
            productos : productos,
            productos_importe:importe,
            productos_descuento:descuento,
            productos_ieps:ieps,
            productos_impuestos:impuesto,

        });

    }

        trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}

    producto_modal(renglon,accion){
      var productos = this.state.productos;
      var compra = this.state.compra;
      var i=parseInt(this.state.indice);
      if(accion=="save"){
       productos.unshift(renglon);
      }else{
        productos[i]=renglon;

      }
      this.calcular_totales(productos,compra);

    }

    eliminar_producto(index){
      var productos = this.state.productos;
      var compra = this.state.compra;

      swal({
        title: 'Estas seguro?',
        text: "Se eliminara  el producto de la lista!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
             productos.splice(index, 1);
             this.calcular_totales(productos,compra);

        }
      })
    }

     handleClose (event) {
        // console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "almacen_codigo":                  
                  campo = "almacen_id";
                  tabla="/busqueda_almacen";
                  break;
            case "proveedor_codigo":                                  
                  campo = "proveedor_id";
                  tabla="/proveedor";                   
                  break;
            case "codigo_lab":                 
                  campo = "lab";
                  tabla="/lab";
                  break;
            case "codigo_via_emb":                  
                  campo = "via_emb";
                  tabla="/embarque";
                  break;      
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                        if(campo=="proveedor_id"){
                            // retorno.saldo="falta funcion";
                        }

                         self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }
                            
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let lab=0;
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        // console.log('renglon---->',objeto);
        let {compra} = this.state;
        let self =this;
        switch (campo) {
            case "proveedor_id":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="proveedor_codigo";
                  campo_descripcion="proveedor_descripcion"; 
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  saldo=objeto.saldo;
                  credito=objeto.credito_formato;
                  bandera=true;
                  compra.plazo_pago=objeto.plazo_credito;
                  compra.lab=objeto.lab?objeto.lab:0;
                  compra.via_emb=objeto.via_emb?objeto.via_emb:0;
                  break;
            case "almacen_id":
                  codigo=objeto.codigo;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="almacen_codigo";
                  campo_descripcion="almacen_descripcion"; 
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "lab":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_lab"; 
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  descripcion="";
                  campo_descripcion="nada"; 
                  break;
            case "via_emb":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_via_emb";
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  descripcion="";
                  campo_descripcion="nada"; 
                  break;     
        }  
       if(vacio==1){
        // console.log('vaciar')
        codigo=valor;
        descripcion="";
        compra[campo] =0;
       }

       // console.log('descripcion--->',descripcion);

       
    if(bandera){
         self.setState({
            compra : compra,           
            [campo_codigo]:codigo,
            [campo_descripcion]:descripcion,
            modal:false, 
            credito:credito,
            saldo:saldo,
            codigo_lab:parseInt(compra.lab)===0?'':compra.lab,
            codigo_via_emb:parseInt(compra.via_emb)===0?'':compra.via_emb,       
        })

    }else{
         self.setState({
            compra : compra,           
            [campo_codigo]:codigo,
            [campo_descripcion]:descripcion,
            modal:false,         
        })

    }
       


    }
    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }   

    toggle_productos(index="nuevo",renglon=[]){
        let {compra} = this.state;
        // console.log('renglon modal-->',renglon);
        // console.log('Indice--->',index);
          if(parseInt(compra.proveedor_id)==0)
          {
             swal("Oops..", "Seleccione un Proveedor");

          }else{
          
            this.setState({
                indice:index,
                modal_productos : !this.state.modal_productos, 
                renglon:renglon,        
            })

          }
          
    }  
   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            compra: {
                ...this.state.compra,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;

        api().get('/tipo_cambio_venta')
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              
              
               self.setState({
                   compra: {
                ...self.state.compra,
               tipo_cambio:response.data.compra
                }
               })
            }

        });

         api().get(`parametros/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                   compra: {
                ...self.state.compra,
               almacen_id:response.data.almacen.id
                },
                almacen_codigo:response.data.almacen.codigo,
                almacen_descripcion:response.data.almacen.nombre

               })

                }

            });

              
        if(prospectoid > 0 && prospectoid != self.state.compra.id)
        {

            api().get(`compra/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {        
                    let bandera= false;
                    if(parseFloat( response.data.compra.total)!= parseFloat(response.data.compra.saldo))  
                    bandera= true;  

                    self.setState({
                        compra: response.data.compra,
                        action: 'update',
                        proveedor_codigo:response.data.proveedor.codigo,
                        proveedor_descripcion:response.data.proveedor.nombre,
                        credito:response.data.proveedor.credito_formato,
                        saldo:response.data.proveedor.saldo,
                        almacen_codigo:response.data.almacen.codigo,
                        almacen_descripcion:response.data.almacen.nombre,
                        codigo_via_emb:parseInt(response.data.compra.via_emb)>0?response.data.compra.via_emb:'',
                        codigo_lab:parseInt(response.data.compra.lab)>0?response.data.compra.lab:'',
                        productos:response.data.productos,
                        abonado:bandera,
                    });

                }

            });
        }
        else if(prospectoid == null && self.state.compra.id)
        {            
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
           compra: {
                id:0,
                factura:'',
                concepto:'',
                fecha: moment().format('Y-MM-DD'),
                folio:'',
                proveedor_id:0,
                almacen_id:0,
                pedimento:'',
                fecha_pedimento:null,
               
                lab:0,
                via_emb:0,
                terminos:0,
                entrega:0,
                dias:0,
                comentario:'',
                recibo:'',
                importe_pagado:0,
                referencia:'',
                concepto_pago:'',
                cargo1:0.00,
                cargo2:0.00,
                impuesto_cargo1:0,
                impuesto_cargo2:0,
                devoluciones:0,
                impuesto_devoluciones:0,
                rebajas:0,
                impuesto_rebajas:0,
                pronto_pago:0,
                impuesto_pronto_pago:0,
                bonificaciones:0,
                impuesto_bonificaciones:0,
                importe:"0.00",
                descuento:"0.00",
                subtotal:"0.00",
                cargos:"0.00",
                ieps:"0.00",
                impuestos:"0.00",
                total:"0.00",  
                 tipo_id:0,   
                motivo:1               
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    



    handleInputChange(event) {
        let {compra} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;
     
        this.setState({
            compra : compra
        });
    }

     objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     if(key!="lista"){
                       objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     }
                        
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {compra,productos} = this.state;
        if(parseInt(compra.cancelado)==1){
          swal("Oops..", "Compra Cancelada ","warning");
          return false;
        } 
        if(this.props.movimientocompra.saving){
          swal("Oops..", "Estamos en Proceso  ","warning");
          return false;
        }
        this.props.peticion();
        console.log('entro al submit')
        
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;  
             
        
            let check = ['factura','concepto','fecha','proveedor_id','almacen_id'];

            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
            check = [
            'proveedor_id',
            'almacen_id',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

            check = [
            'cargo1',
            'cargo2',
            'impuesto_cargo1',
            'impuesto_cargo2',
            'devoluciones',
            'impuesto_devoluciones',
            'rebajas',
            'impuesto_rebajas',
            'pronto_pago',
            'impuesto_pronto_pago',
            'bonificaciones',
            'impuesto_bonificaciones',
            'importe_pagado'
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(isNaN(parseInt( value))) {
                save = false;
                break;
            }
                
            }
            let lista=[];
            if(save){

              
              if(productos.length === 0) {
                save=false;
                mensaje=false;

                  swal("Oops..", "Por favor Verificar la lista de los productos ");

              }else{

                lista=productos;
              } 
            }

            compra.lista=lista;            
             
           if(action=='save'){
          // console.log('action--->',action);
          // console.log('se modificaron los saldos  nuevo registro');
           compra.saldo=compra.total;
           compra.saldo_impuesto=compra.impuestos; 
           compra.saldo_subtotal=compra.total-compra.impuestos;
           }
               
        compra=this.objeto_mayusculas(compra);
        

        if(save   ){


          api().post(`/compra_validar`, compra)
            .then(function(response)
            {
                let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];

                if(validacion||(parseInt(encontrado.id)===parseInt(compra.id) )){
                        self.props[action](compra, (data) => {

                           self.props.alerta({
                            mensaje:"Compra Guardado correctamente!",
                            tipo:"success",
                            creacion:moment().format('Y-MM-DD H:m:s'),
                            });
                            self.props.toggle();
                            self.resetModal();
                    
                });

                }else{
                    swal("Oops..", "La Factura ya existe");
                     self.props.peticion_fail();
                }
            });

        }else{
          if(productos.length > 0||mensaje==true)
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render()
    {

        let {compra}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle_tab('3'); }}
                        >
                         Productos
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-2">
                            <FormGroup>
                                <Label>Factura *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura"
                                    maxLength={15}
                                    value={compra.factura} 
                                    onChange={this.handleInputChange}  />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Concepto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="concepto"
                                    maxLength={75}
                                    value={compra.concepto} 
                                    onChange={this.handleInputChange}  />
                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha *:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={compra.fecha || ''}
                                    onChange={this.handleInputChange}
                                   
                                />
                            </div>
                        </div>
                        

                        <div className="col-md-2">
                            <FormGroup>
                                <Label></Label>
                                    
                            </FormGroup>
                        </div>

                        </div>
                         <div className="row form_cliente">
                         <div className="col-12 col-sm-6 col-md-2">
                              <div className="form-group">
                                <label className>Moneda:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="moneda"
                                  options={tipos_precios}
                                  value={parseInt(compra.moneda) || 0}
                                  onChange={ (select) => { this.handleSelectChange(select, 'moneda') } }
                                  disabled={ this.state.abonado==true ?true:false}
                                  clearable={false}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>T.C.</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="tipo_cambio"
                                    value={compra.tipo_cambio} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>
                         <div className="col-12 col-sm-6 col-md-2">
                              <div className="form-group">
                                <label className>Tipo de Compra:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="tipo_id"
                                  options={tipos_compra}
                                  value={parseInt(compra.tipo_id) || 0}
                                  onChange={ (select) => { this.handleSelectChange(select, 'tipo_id') } }
                                  
                                  clearable={false}
                                />
                              </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                              <div className="form-group">
                                <label className>Motivo:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="motivo"
                                  options={motivos}
                                  value={parseInt(compra.motivo) || 0}
                                  onChange={ (select) => { this.handleSelectChange(select, 'motivo') } }
                                  
                                  clearable={false}
                                />
                              </div>
                          </div>
                         </div>
                         <div className="row form_cliente">
                         <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Proveedor *:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="proveedor_codigo"
                                            value={this.state.proveedor_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                           disabled={ parseInt( compra.id)>0 ?true:false}
                                            />
                                            <Button disabled={ parseInt( compra.id)>0 ?true:false} onClick={ (button) => { this.toggle_modal(14,"Proveedores","proveedor_id") } }>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.proveedor_descripcion}</label>
                                </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Almacen *:</label>
                                            <Input
                                            placeholder=""
                                            name="almacen_codigo"
                                            value={this.state.almacen_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                             className="input_button"
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen_id") } }>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.almacen_descripcion}</label>
                                </div>
                                </div>

                            </div>               
                         </div>
                        <div className="row form_cliente">
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Pedimento</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="pedimento"
                                    maxLength={25}
                                    value={compra.pedimento} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className>Fecha Ped.:</label>
                                    <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha_pedimento"
                                    value={compra.fecha_pedimento || ''}
                                    onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                            

                            <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo Via/Emb:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_via_emb"
                                    value={this.state.codigo_via_emb}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"

                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(21,"Vias de Embarque","via_emb") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label># Guia.</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="guia"
                                    value={compra.guia}
                                    maxLength={30} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>                
                        </div>
                        <div className="row form_cliente">
                        <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo de Lab:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_lab"
                                    value={this.state.codigo_lab}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(22,"Conceptos Lab","lab") } }>...</Button>
                                </div>
                            </div>   
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Plazo/Pago</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="plazo_pago"
                                    value={compra.plazo_pago} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Terminos</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="terminos"
                                    value={compra.terminos} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Entrega</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="entrega"
                                    value={compra.entrega}
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Dias</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="dias"
                                    value={compra.dias} 
                                    onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>                
                        </div>
                        
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="comentario"
                                      value={compra.comentario} 
                                      maxLength={350}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <Col sm="12">
                                <div className="row mt-3 form_cliente">
                                    <div className="col-md-12 text-right">
                                       <label className="mr-4" ><b>Moneda: {tipos_precios[parseInt( compra.moneda)].label}</b> </label>
                                       <label className="mr-4" ><b>Saldo: {this.state.saldo}</b> </label>
                                       <label className="mr-4" ><b>Credito Disponible: {this.state.credito} </b></label>
                                        <Button color="success" className="mb-2"  onClick={()=>this.toggle_productos(null,[])}>
                                    &nbsp;Agregar
                                       </Button>
                                    </div>
                                    <div className="col-md-12">    
                                                <ReactTable
                                                  getTrProps={(state, rowInfo, column) => {                                  
                                                      if(rowInfo === undefined){                                          
                                                              return{
                                                              }
                                                            }else{
                                                               return{
                                                                onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Usuario')
                                                            }                                   
                                                        }
                                                  }}
                                                  data      = {this.state.productos}
                                                  className = "-striped -highlight"
                                                  columns   = {[

                                                    {
                                                        Header: 'Controles',
                                                        filterable: false,
                                                        sortable: false,
                                                        maxWidth:150,
                                                        Cell: (row) =>
                                                        {
                                                            return(
                                                                <div className="text-right">
                                                                <Button
                                                                     color="primary" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.toggle_productos(row.index,row.original)}>
                                                                        <IconEdit />
                                                                    </Button>{' '}
                                                                    <Button
                                                                     color="danger" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.eliminar_producto(row.index)}>
                                                                        X
                                                                    </Button>{' '}
                                                                     
                                                                </div>
                                                            )
                                                        }
                                                    },
                                                   
                                                    {Header: 'Clave', accessor: 'codigo',maxWidth:100,minWidth:100 , style: { 'textAlign': 'center'}},
                                                    {Header: 'Codigo Art', accessor: 'codigo_proveedor',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Descripcion', accessor: 'nombre' ,minWidth:500, style: { 'textAlign': 'center'}},                    
                                                    {Header: 'Unidades', accessor: 'cantidad',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Costo', accessor: 'costo',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Unid * Costo', accessor: 'costo_total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Desc. %', accessor: 'descuento',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Descuento', accessor: 'cantidad_descuento',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Importe', accessor: 'importe',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'IEPS', accessor: 'ieps_total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp1 %', accessor: 'impuesto1',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp 1', accessor: 'cantidad_impuesto1',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp2 %', accessor: 'impuesto2',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp 2', accessor: 'cantidad_impuesto2',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Total', accessor: 'total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},                                                  
                                                  ]}
                                                  filterable 
                                                  pageSizeOptions= {[5]}
                                                  defaultPageSize={5} 
                                                  defaultFilterMethod={filterCaseInsensitive}
                                                />
                                    </div>

                                </div>
                                <div className="row mt-3 form_cliente">
                                    
                                     <div className="col-md-3">
                                        <div className="row mt-3 div_titulo m-0">
                                            <h1 style={{ width: '100%'}}><span>Cargos</span></h1>                                         
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>+Diverso 1</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="cargo1"
                                                    value={compra.cargo1} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Impuesto</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="impuesto_cargo1"
                                                    value={compra.impuesto_cargo1} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>+Diverso 2</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="cargo2"
                                                    value={compra.cargo2} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Impuesto</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="impuesto_cargo2"
                                                    value={compra.impuesto_cargo2} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row mt-3 div_titulo m-0">
                                            <h1 style={{ width: '100%'}}><span> Abonos</span></h1>
                                            <div className="col-md-6">
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Devoluciones</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="number"
                                                        name="devoluciones"
                                                        value={compra.devoluciones} 
                                                        onChange={this.handleInputChangeConteo}  />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Impuesto</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="number"
                                                        name="impuesto_devoluciones"
                                                        value={compra.impuesto_devoluciones} 
                                                        onChange={this.handleInputChangeConteo}  />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Rebajas</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="number"
                                                        name="rebajas"
                                                        value={compra.rebajas} 
                                                        onChange={this.handleInputChangeConteo}  />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Impuesto</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="number"
                                                        name="impuesto_rebajas"
                                                        value={compra.impuesto_rebajas} 
                                                        onChange={this.handleInputChangeConteo}  />
                                                    </FormGroup>
                                            </div>
                                            </div>
                                            </div>
                                            <div className="col-md-6">
                                            <div className='row'>
                                                 <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Descto. pronto P.</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="pronto_pago"
                                                    value={compra.pronto_pago} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Impuesto</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="impuesto_pronto_pago"
                                                    value={compra.impuesto_pronto_pago} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Bonificaciones</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="bonificaciones"
                                                    value={compra.bonificaciones} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Label>Impuesto</Label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="impuesto_bonificaciones"
                                                    value={compra.impuesto_bonificaciones} 
                                                    onChange={this.handleInputChangeConteo}  />
                                                </FormGroup>
                                            </div>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="row mt-3">
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Importe: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.importe}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Descuento: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.descuento}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Subtotal: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.subtotal}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Cargos: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.cargos}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>IEPS: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.ieps}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Impuestos: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>{"$"+compra.impuestos}</Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                               
                                                    <b><span><Label>Total: </Label></span></b>
                                                
                                            </div>
                                            <div className="col-6 text-left">
                                                
                                                    <b><span><Label>{"$"+compra.total}</Label></span></b>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </TabPane>                        
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.movimientocompra.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                />
                }
                {
                   this.state.modal_productos&&
                   <ProductosModal 
                 open={this.state.modal_productos} 
                 toggle={this.toggle_productos} 
                 title={"Producto"} 
                 renglon={this.state.renglon}
                 retorno={this.producto_modal}
                 id={this.state.indice}                   
                />
                }

                 {
                   this.state.modal_registro==21&& 
                   <Embarques 
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==22&& 
                   <LAB
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==14&& 
                   <Proveedor 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==25&& 
                   <Almacen 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                 
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        movimientocompra : state.movimientocompra,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(EmbarqueModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscompras/Modal.js